module.exports = __webpack_public_path__ + "static/media/icon-bar-chart.14dc776c.svg";